// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"0e5c2ee3","977":"48f15c7a"}[chunkId] + ".chunk.js";
};